import React from "react";

export default class NotifyToast extends React.Component {
    render() {
        const { message, variant = "default", icon } = this.props;
        const variantClass = variant && variant !== "default" ? ` notify-toast--${variant}` : "";

        return (
            <div className={`notify-toast${variantClass}`}>
                <div className="notify-toast__dialog">
                    <div className="notify-toast__content">
                        <div className="notify-toast__stack">
                            <p>
                                {icon && <i className="toast-icon">{icon}</i>}
                                <span>{message}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
